import { Store } from "@interfaces/Store";
import React from "react";
import { storeService } from "@services";
import { DataTable } from "../Common";
import { DataTableColumn } from "../Common/DataTable/DataTable";
import { useCurrentPageInfo, useModal } from "@hooks";
import { useSnackbar } from "notistack";
import { ServiceHelper } from "@modules";

const StoresTable = () => {
    const { permission } = useCurrentPageInfo();
    const { handleOpenModal } = useModal();
    const { enqueueSnackbar } = useSnackbar();

    const handleEditClick = (rowData) => {
        handleOpenModal("EDIT_STORE", {
            itemId: rowData.id,
            titleProps: rowData.id,
        });
    };

    // VMA - 11-06-2024
    const handleDeleteClick = async (rowData: Store | Store[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await storeService.deleteStores(ids);
            enqueueSnackbar("Магазины успешно удалены", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении магазинов", {
                variant: "error",
            });
        }
    };

    const columns: DataTableColumn<Store>[] = [
        {
            title: "#",
            field: "id",
            defaultSort: "asc",
            align: "left",
            type: "numeric",
            width: 100,
        },
        {
            title: "ID Магазина",
            field: "store_id",
            align: "left",
            type: "numeric",
            width: "auto",
        },
        {
            title: "Сортировка",
            field: "sorting",
            align: "left",
            type: "numeric",
            width: "auto",
        },
        {
            title: "Является магазином",
            field: "is_shop",
            type: "boolean",
            width: 10,
        },
        {
            title: "Учитывать остатки",
            field: "is_countable",
            type: "boolean",
            width: 10,
        },
        {
            title: "Название",
            field: "store_name",
            width: "auto",
        },
        {
            title: "Отображаемое название",
            field: "shown_name",
            width: "auto",
        },
        {
            title: "Комментарий",
            field: "comment",
            width: "auto",
        },
    ];

    return (
        <DataTable
            fetchFn={storeService.getStores}
            columns={columns}
            displayField="store_name"
            permission={permission}
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            onMassDeleteClick={handleDeleteClick}
            filtering
            sorting
            search
        />
    );
};

export default StoresTable;
